
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Mumbaiairporttopuneertigaonrent() {



    const cardData =
    {
        keyword: 'Mumbai Airport to Pune Ertiga on Rent  ',
        heading: 'Vedant Travels: Mumbai Airport to Pune Ertiga on Rent ',
        headingDescription: 'Vedant Travels offers a convenient and comfortable Ertiga rental service for your journey from Mumbai Airport to Pune. The Ertiga is an ideal choice for families or small groups, offering ample space, comfort, and great value for money. Whether you’re traveling for business or leisure, our well-maintained vehicles and professional drivers ensure a smooth, safe, and pleasant ride.',

        top: 'Top Places to Visit in Pune with Vedant Travels',

       "topPlaces": [
        {
            "title": "Shaniwar Wada",
            "description": "A historic fort that was once the residence of the Peshwa rulers, Shaniwar Wada is a must-visit for history enthusiasts. The fort features impressive Maratha architecture and offers an engaging light-and-sound show that brings its fascinating history to life."
        },
        {
            "title": "Aga Khan Palace",
            "description": "Built in 1892, the Aga Khan Palace is not only a beautiful structure but also a significant historical site. It was used as a prison during the freedom struggle, and Mahatma Gandhi and his associates were held here. The palace is surrounded by lush gardens, providing a peaceful atmosphere for reflection."
        },
        {
            "title": "Sinhagad Fort",
            "description": "Located 35 km from Pune, Sinhagad Fort is a popular destination for trekkers and history lovers. The fort offers stunning views of the surrounding valleys and is known for its role in Maratha history. It’s a great place for those seeking adventure and historical exploration."
        },
        {
            "title": "Osho Ashram",
            "description": "Situated in Koregaon Park, the Osho Ashram is a globally recognized meditation and spiritual retreat center. Visitors can participate in a variety of meditation sessions and spiritual workshops, making it an ideal spot for relaxation and inner peace."
        },
        {
            "title": "Raja Dinkar Kelkar Museum",
            "description": "The Raja Dinkar Kelkar Museum houses a vast collection of Indian artifacts, including sculptures, musical instruments, and daily-use items from different historical periods. It’s a fascinating stop for anyone interested in India’s cultural heritage."
        },
        {
            "title": "Pune Okayama Friendship Garden (Pu La Deshpande Garden)",
            "description": "A beautiful Japanese-inspired garden located in Pune, this garden is perfect for a relaxing stroll. With lush greenery, vibrant flowers, and serene ponds, it offers a peaceful escape from the busy city life."
        },
        {
            "title": "Pashan Lake",
            "description": "Pashan Lake is a serene spot, perfect for nature lovers and birdwatching enthusiasts. Surrounded by lush greenery, it provides a quiet environment for photography, walks, and peaceful reflection."
        },
        {
            "title": "Bund Garden",
            "description": "Bund Garden is a riverside park ideal for a relaxing walk, boating, or picnicking. The tranquil atmosphere and natural beauty make it a lovely spot to unwind and enjoy time with family or friends."
        },
        {
            "title": "Saras Baug",
            "description": "Saras Baug is a popular temple complex in Pune, known for its beautiful Ganesha temple and peaceful gardens. It’s a great place to enjoy a leisurely walk, relax in the gardens, or simply seek spiritual solace."
        },
        {
            "title": "Fergusson College",
            "description": "One of Pune’s oldest and most prestigious educational institutions, Fergusson College is known for its colonial-era architecture and rich academic history. It’s a beautiful campus to explore, showcasing Pune’s educational legacy and architectural beauty."
        }
    ],
    "services": [
        {
            "name": "Mumbai Airport to Pune Ertiga on Rent",
            "description": "Looking for a comfortable and affordable ride from Mumbai Airport to Pune? Rent an Ertiga from Vedant Travels for a smooth, spacious, and economical journey. Perfect for family trips or small group travel."
        },
        {
            "name": "Mumbai to Pune Ertiga Cab",
            "description": "Book a reliable Ertiga cab from Mumbai to Pune for a hassle-free journey. Enjoy a spacious and comfortable ride with an experienced driver, perfect for a peaceful and pleasant trip."
        },
        {
            "name": "Navi Mumbai to Pune Ertiga Cab",
            "description": "Travel from Navi Mumbai to Pune in comfort with our Ertiga cabs. Book an Ertiga for a smooth ride, spacious interior, and a professional driver to ensure your comfort and safety throughout the journey."
        },
        {
            "name": "Dadar to Pune Ertiga Cab Booking",
            "description": "Need a ride from Dadar to Pune? Book an Ertiga cab for a comfortable and cost-effective journey. Our Ertiga vehicles are spacious and well-maintained, ensuring a pleasant travel experience."
        },
        {
            "name": "One Way Ertiga Cab Booking",
            "description": "Choose our one-way Ertiga cab service for a hassle-free, one-way trip between Mumbai and Pune. Our experienced drivers and spacious vehicles make your journey comfortable and efficient."
        },
        {
            "name": "7 Seater Car Rental Mumbai Airport",
            "description": "Looking for a 7-seater car rental at Mumbai Airport? Rent a spacious vehicle for your group travel or family trip. Enjoy a comfortable ride with our well-maintained fleet and professional drivers."
        },
        {
            "name": "6 Seater Car Rental Mumbai Airport",
            "description": "Need a 6-seater car rental at Mumbai Airport? Choose from a range of comfortable and spacious vehicles, perfect for small group travel. Our rental service ensures timely pick-up and drop-off with a professional driver."
        },
        {
            "name": "Pune to Mumbai Airport Drop Taxi Service",
            "description": "Book a reliable taxi for your drop from Pune to Mumbai Airport. Our vehicles, including Ertiga, ensure a smooth and timely ride with comfortable seating, perfect for reaching your destination without any stress."
        },
        {
            "name": "Mumbai to Pune Ertiga Hire",
            "description": "Hire an Ertiga for your Mumbai to Pune journey. Our rental services ensure a comfortable, spacious, and smooth travel experience. Perfect for families and groups, we offer flexible and affordable hire options."
        }
    ],

    "tableData": [
        ["Mumbai Airport to Pune Ertiga on Rent", "Mumbai to Pune Ertiga Cab"],
        ["Navi Mumbai to Pune Ertiga Cab", "Dadar to Pune Ertiga Cab Booking"],
        ["One Way Ertiga Cab Booking", "7 Seater Car Rental Mumbai Airport"],
        ["6 Seater Car Rental Mumbai Airport", "Pune to Mumbai Airport Drop Taxi Service"],
        ["Mumbai to Pune Ertiga Hire", ""]
      ],
      "whychoose": [
        {
          "WhyChooseheading": "Reliable and On-Time Service",
          "WhyChoosedescription": "At Vedant Travels, we understand the importance of punctuality, especially when traveling from Mumbai Airport to Pune. Whether you’re arriving for a business trip or a family vacation, our drivers ensure timely pickups and smooth travel to make your journey hassle-free."
        },
        {
          "WhyChooseheading": "Comfortable and Spacious Ertiga",
          "WhyChoosedescription": "Our Ertiga cabs are perfect for long-distance travel, offering comfort, space, and a smooth ride. With ample seating for up to 6 passengers, it’s an ideal choice for families or small groups traveling from Mumbai Airport to Pune. The air-conditioned vehicle ensures a pleasant journey, with enough space for your luggage and comfort during the trip."
        },
        {
          "WhyChooseheading": "Experienced and Professional Drivers",
          "WhyChoosedescription": "Our drivers are well-trained and experienced in handling long-distance routes like Mumbai Airport to Pune. They ensure your journey is safe, comfortable, and efficient, knowing the best routes and how to navigate any traffic conditions. You can trust them to provide the best possible service and a smooth experience."
        },
        {
          "WhyChooseheading": "Affordable and Transparent Pricing",
          "WhyChoosedescription": "We offer competitive and transparent pricing for the Mumbai Airport to Pune Ertiga on Rent service. There are no hidden charges, and you’ll know the exact fare before you begin your journey, ensuring complete transparency and no surprises at the end."
        },
        {
          "WhyChooseheading": "Safe and Comfortable Journey",
          "WhyChoosedescription": "Your safety is our top priority. All our Ertiga vehicles are regularly maintained and equipped with modern safety features such as airbags, seat belts, and GPS tracking. Our drivers adhere to strict safety protocols to ensure that your journey is secure and stress-free."
        },
        {
          "WhyChooseheading": "24/7 Availability",
          "WhyChoosedescription": "Whether you’re arriving at Mumbai Airport early in the morning or late at night, Vedant Travels is available round the clock for your Mumbai Airport to Pune Ertiga on Rent needs. We are always ready to assist you with your travel plans."
        },
        {
          "WhyChooseheading": "Hassle-Free Booking Process",
          "WhyChoosedescription": "Booking your Ertiga from Mumbai Airport to Pune with Vedant Travels is quick and easy. You can book online through our website or mobile app, or simply contact our customer service team for assistance. We ensure a smooth booking experience with minimal effort required on your part."
        },
        {
          "WhyChooseheading": "Customizable Travel Packages",
          "WhyChoosedescription": "Whether you’re traveling for business or leisure, we offer customizable travel packages for your Mumbai Airport to Pune Ertiga journey. If you have specific requests, such as sightseeing stops along the way or a detour for a quick break, just let us know, and we’ll tailor the journey to your preferences."
        }
      ]

    }



    const faqData = [
        {
            id: 1,
            question: 'How can I book a Mumbai Airport to Pune Ertiga on Rent with Vedant Travels?',
            answer: 'You can easily book an Ertiga on Rent from Mumbai Airport to Pune via our website or mobile app. Alternatively, you can contact our customer service team, who will assist you with the booking process.',
        },
        {
            id: 2,
            question: 'How many people can the Ertiga accommodate?',
            answer: 'The Ertiga can comfortably seat up to 6 passengers, making it perfect for families or small groups traveling from Mumbai Airport to Pune.',
        },
        {
            id: 3,
            question: 'What are the payment options for booking the Mumbai Airport to Pune Ertiga on Rent?',
            answer: 'We accept multiple payment options, including cash, credit/debit cards, and online payments through our app for your convenience.',
        },
        {
            id: 4,
            question: 'Are there any additional charges for waiting at Mumbai Airport?',
            answer: 'Any additional charges for waiting time at Mumbai Airport will be communicated to you during the booking process. We believe in transparency, and you’ll know exactly what to expect before your journey.',
        },
        {
            id: 5,
            question: 'Can I book a round-trip Ertiga from Mumbai to Pune?',
            answer: 'Yes, we offer round-trip Ertiga on Rent services. Simply provide us with your return details during the booking process, and we will arrange everything for you.',
        },
        {
            id: 6,
            question: 'Can I request a driver for sightseeing on the way from Mumbai to Pune?',
            answer: 'Yes, we offer sightseeing options as part of your Mumbai Airport to Pune Ertiga journey. If you’d like to stop at scenic spots or popular landmarks along the way, we can customize the trip to include these stops.',
        },
        {
            id: 7,
            question: 'What is the luggage allowance for an Ertiga?',
            answer: 'The Ertiga offers generous luggage space, making it ideal for longer trips. If you have excess luggage or special requirements, please inform us at the time of booking, and we will accommodate your needs.',
        },
        {
            id: 8,
            question: 'Is Vedant Travels available for corporate travel from Mumbai Airport to Pune?',
            answer: 'Yes, we offer corporate travel services for business trips. Whether it’s a single trip or transportation for a team, we can customize the experience to suit your company’s needs with the comfort of an Ertiga.',
        },
        {
            id: 9,
            question: 'Why should I choose Vedant Travels for my Mumbai Airport to Pune Ertiga journey?',
            answer: 'Vedant Travels offers reliable, affordable, and safe transportation. Our Ertiga on Rent service is ideal for families, small groups, and business travelers. We ensure a comfortable, safe, and enjoyable trip with professional drivers and well-maintained vehicles.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Rahul Joshi",
            title: "Family Traveler",
            quote: "I had a fantastic experience with Vedant Travels. The Ertiga was spacious, clean, and very comfortable for my family of 5. Our driver was punctual, and the journey from Mumbai Airport to Pune was smooth and relaxing. Highly recommend it!",
            rating: 5,
        },
        {
            name: "Mrs. Snehal Patil",
            title: "Group Traveler",
            quote: "I needed a reliable ride from Mumbai Airport to Pune, and Vedant Travels delivered just that. The Ertiga was perfect for my group of 6, and the driver was courteous and professional. A stress-free experience from start to finish!",
            rating: 5,
        },
    ];
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8767459909",

        ],
        email: "booking@vedanttravels.in"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai Airport to Pune Ertiga on Rent",
  "image": "https://vedanttravels.in/assets/images/mumbai-airport-to-pune-ertiga-on-rent.jpg",
  "description": "Rent an Ertiga from Mumbai Airport to Pune with Vedant Travels for a comfortable and affordable journey. Ideal for families and groups with flexible rental options and professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Vedant Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "3800"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2799",
    "availability": "https://schema.org/InStock",
    "url": "https://vedanttravels.in/mumbai-airport-to-pune-ertiga-on-rent"
  }
};



      
     


    return (
        <div>
           
          <Helmet>
  <title>Mumbai Airport to Pune Ertiga on Rent | Comfortable & Affordable | Vedant Travels</title>
  <meta 
    name="description" 
    content="Rent an Ertiga from Mumbai Airport to Pune with Vedant Travels for a comfortable and affordable journey. Ideal for families and groups with flexible rental options and professional drivers." 
  />
  <meta 
    name="keywords" 
    content="Mumbai Airport to Pune Ertiga on Rent, Ertiga Rental Mumbai Airport Pune, Ertiga on Hire Mumbai to Pune, Rent Ertiga Mumbai Pune, Family Car Rental Mumbai Airport, Affordable Ertiga Rental Pune, Vedant Travels Ertiga Rental, Online Car Rental Mumbai Pune, Comfortable Ertiga Ride, Professional Driver Ertiga Rental" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      
            <div
                className="site-breadcrumb"
                style={{ background: 'url(/img/breadcrumb/01.jpg)' }}
            >
                <div className="container">
                    <h2 className="breadcrumb-title">{cardData.keyword}</h2>

                </div>
            </div>

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <h1 className='text-white'>{cardData.keyword}</h1>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/57.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vedant Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonials={testimonials} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #006BB7',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#006BB7' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918767459909" className="d-block  text-white">+91 8767459909</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@vedanttravels.in" className=" text-white d-block">
                                                    booking@vedanttravels.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Vedant Travels <br/>
                                                    S/R No. 66/1. Dhore Patil Farm,<br/>
                                                    Near New  Bharat Bakery,
                                                    New Sangvi <br/>Pimpri-Chinchwad,
                                                    Pune Maharashtra India- 411027.
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaiairporttopuneertigaonrent;